var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSkipForward = function SvgIconSkipForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.75 3.75a1 1 0 1 1 2 0v16.5a1 1 0 1 1-2 0v-6.47L6.919 20.406l-.002.002a1.75 1.75 0 0 1-2.667-1.504V5.095a1.75 1.75 0 0 1 2.667-1.504l.002.002L17.75 10.22zM16.826 12 6.25 5.528v12.944z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSkipForward;